import React, { useState, useEffect } from "react";
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { useJwt } from "react-jwt";
import Sidebar from "../components/Sidebar";
import { FaStar } from "react-icons/fa";
import Select from "react-select";
import {
  CreateBrand,
  GetProductStatus,
  GetPageNumber,
  CreateWidget,
  GetPincodeProduct,
  GetProductCatWithoutPage,
  GetProductSubCatWithoutPage,
  EditWedgetProduct,
} from "../apiconfig/authService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiLoaderFill } from "react-icons/ri";

function Addwidget(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setProductViewMessage = props.setMessage;
  const [widget, setWidget] = useState("");
  const [categoryStatusid, setCategoryStatusid] = useState(1);
  const [type, setType] = useState("");
  const [statusData, setStatusData] = useState(null);
  const [pagenumber, setPagenumber] = useState([1]);
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [categoryID, setCategoryID] = useState(-1);
  const [subcategoryID, setSubcategoryID] = useState(-1);
  const [visibleSubcategories, setVisibleSubcategories] = useState([]);
  const [refetchData, setRefetchData] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  const [page, setPage] = useState(1);
  const [isMessageRed, setIsMessageRed] = useState(false);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");
  const [selectedPageNumber, setSelectedPageNumber] = useState([]);
  const [position, setPosition] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState({ products: [] });

  const handleStatusIdChange = (e) => {
    setCategoryStatusid(Number(e.target.value));
  };

  const handleWidgetChange = (e) => setWidget(e.target.value);

  const handlePositionChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 1) {
      setPosition(value);
    } else {
      setPosition(1);
    }
  };

  const handleTypeChange = (e) => {
    const newType = e.target.value;
    setType(newType);

    // Reset relevant states when type changes
    if (newType === "category") {
      setSubcategoryID(-1);
      setCategoryID(-1);
      setProductData({ products: [] });
    } else if (newType === "product") {
      setSelectedCategories([]);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        const pageNumber = await GetPageNumber(
          localStorage.getItem("accessToken")
        );
        setPagenumber(pageNumber.data);
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    // Validate the widget title and page number
    if (!widget.trim()) {
      toast.error("Widget title is required!");
      return;
    }

    if (!selectedPageNumber || selectedPageNumber.length === 0) {
      toast.error("At least one page must be selected!");
      return;
    }

    if (type === "") {
      toast.error("Widget type is required!");
      return;
    }

    if (position === "") {
      toast.error("Position is required!");
      return;
    }

    if (!/^\d+$/.test(position)) {
      toast.error("Position must be a valid number!");
      return;
    }

    if (type === "category" && selectedCategories.length === 0) {
      toast.error("Select at least one category!");
      return;
    }

    if (type === "product") {
      if (categoryID === -1) {
        toast.error("Select a category to filter products!");
        return;
      }

      if (!productData?.products || productData.products.length === 0) {
        toast.error("Select at least one product!");
        return;
      }
    }

    try {
      setLoading(true);

      const categoryPayload = type === "category" ? selectedCategories : [];

      const response = await CreateWidget(
        {
          type: type,
          title: widget,
          statusid: categoryStatusid,
          pagenumber: selectedPageNumber,
          category: categoryPayload,
          products:
            type === "product"
              ? productData?.products?.map((p) => p.value)
              : [],
          position: position,
        },
        localStorage.getItem("accessToken")
      );

      if (response.status === 200) {
        setLoading(false);
        toast.success("Widget Added Successfully!");
        setProductViewMessage("Widget Added Successfully!");
        navigate("/wedget");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.error ||
          "An error occurred. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const pagenumber = await GetPageNumber(
          localStorage.getItem("accessToken")
        );
        const productData = await GetPincodeProduct(
          search,
          localStorage.getItem("accessToken"),
          categoryID,
          subcategoryID
        );
        setProduct(productData.data.products.items);
        setPagenumber(pagenumber.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [id, search, refetchData, categoryID, subcategoryID]);

  useEffect(() => {
    (async () => {
      const categoryResponse = await GetProductCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      const subCategoryResponse = await GetProductSubCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      setCategories(categoryResponse.data.categories);
      setSubcategories(subCategoryResponse.data.subcategories);
    })();
  }, []);

  const handleProductChange = (selectedOptions) => {
    setProductData({
      products: selectedOptions.map((option) => ({
        value: option.value,
        label: option.label,
        image: option.image,
      })),
    });
  };

  const handleSubcategoryIDChange = (e) => {
    setSubcategoryID(Number(e.target.value));
  };

  const handleCategoryIDChange = (e) => {
    const newCategoryID = Number(e.target.value);
    setCategoryID(newCategoryID);
    setSubcategoryID(-1);
    setProductData({ products: [] }); // Reset selected products when category changes

    setVisibleSubcategories(
      subcategories.filter((item) => item.categoryid === e.target.value)
    );
  };

  const handleSearchBoxSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    setRefetchData(!refetchData);
  };

  const productOptions = product.map((item) => ({
    value: item._id,
    label: item.name,
    image: item.imageurl,
    weight: item.weight,
  }));

  const handlePageChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setSelectedPageNumber([...selectedValues]);
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Widget</h1>
        </div>
        <div className="personal-info tab-pane active storetab">
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="brandName">Widget Title</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={widget}
                onChange={handleWidgetChange}
                className="form-control custom-input my-2"
                id="widget"
                placeholder="Enter Widget Title"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="floatingInput">Page Name</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <Select
                isMulti
                options={pagenumber?.map((item) => ({
                  value: item?.pagenumber,
                  label: item?.pagename,
                }))}
                value={selectedPageNumber
                  ?.map((page) => {
                    const pageData = pagenumber.find(
                      (item) => item?.pagenumber === page
                    );
                    return pageData
                      ? { value: pageData.pagenumber, label: pageData.pagename }
                      : null;
                  })
                  .filter(Boolean)}
                onChange={handlePageChange}
                className="basic-multi-select my-3"
                classNamePrefix="select"
                placeholder="Select Pages"
              />
            </div>
          </div>

          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <label htmlFor="floatingInput">Status</label>
            <select
              className="form-select custom-input my-2"
              onChange={handleStatusIdChange}
              value={categoryStatusid}
            >
              {statusData?.map((item) => (
                <option key={item.statusid} value={item.statusid}>
                  {item.status}
                </option>
              ))}
            </select>
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="floatingInput">Type</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <select
                className="form-select custom-input my-2"
                onChange={handleTypeChange}
                value={type}
              >
                <option value="">Select Type</option>
                <option value="category">Category</option>
                <option value="product">Product</option>
              </select>
            </div>

            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="d-flex">
                <label htmlFor="brandName">Position</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="number"
                value={position}
                onChange={handlePositionChange}
                className="form-control custom-input my-2"
                id="widget"
                placeholder="Enter Widget Position"
                min={1}
              />
            </div>
          </div>

          {/* Category Section */}
          {type && (
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="d-flex">
                  <label htmlFor="floatingInput">
                    {type === "category"
                      ? "Categories"
                      : "Category (for filtering products)"}
                  </label>
                  <FaStar size={7} className="text-danger" />
                </div>
                {type === "category" ? (
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={categories.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                    value={categories
                      .filter((cat) => selectedCategories.includes(cat._id))
                      .map((cat) => ({
                        value: cat._id,
                        label: cat.name,
                      }))}
                    onChange={(selected) =>
                      setSelectedCategories(
                        selected.map((option) => option.value)
                      )
                    }
                    placeholder="Select Categories"
                    className="custom-select my-2"
                  />
                ) : (
                  <select
                    className="form-select my-2"
                    value={categoryID}
                    onChange={handleCategoryIDChange}
                  >
                    <option value={-1}>
                      Select Category for Product Filtering
                    </option>
                    {categories
                      ?.sort((a, b) => a.name.localeCompare(b.name))
                      .map((item) => (
                        <option key={item.categoryid} value={item.categoryid}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            </div>
          )}

          {/* Product Selection - Only show for product type */}
          {type === "product" && (
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <div className="d-flex">
                <label htmlFor="productSelect">Select Products</label>
                <FaStar size={7} className="text-danger" />
              </div>
              {categoryID !== -1 ? (
                <Select
                  options={productOptions}
                  isMulti
                  onChange={handleProductChange}
                  closeMenuOnSelect={false}
                  onInputChange={(inputValue) => setSearch(inputValue)}
                  filterOption={null}
                  value={productData.products}
                  getOptionLabel={(option) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={option.image}
                        alt={option.label}
                        style={{ width: 20, height: 20, marginRight: 10 }}
                      />
                      <span>{option.label}</span>
                      <span
                        style={{
                          color: "#757575",
                          fontSize: "14px",
                          marginLeft: "15px",
                        }}
                      >
                        ({option.weight})
                      </span>
                    </div>
                  )}
                  getOptionValue={(option) => option.value}
                  placeholder="Search and Select Products"
                  className="my-2"
                />
              ) : (
                <div className="alert alert-info my-2">
                  Please select a category first to filter and select products.
                </div>
              )}
            </div>
          )}

          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                    onClick={handleSubmitClick}
                    disabled={loading}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>

      <ToastContainer />
    </div>
  );
}

export default Addwidget;
